// eslint-disable-next-line monorepo/no-internal-import -- to prevent type check errors in legacy
import {Environment} from '@aboutyou/config/src/environment';

export const WINDOW_LOGGER_GLOBAL_CONFIG_NAME = '__logger_global_config_';

export enum DD_BROWSER_LOGGERS {
  CRITICAL_LOGS = 'critical-logs',
  NON_CRITICAL_LOGS = 'non-critical-logs',
  CUSTOM_ERROR_LOGS = 'custom-error-logs',
  WARNING_LOGS = 'warning-logs',
  DEBUG_LOGS = 'debug-logs',
  WEB_VITALS = 'web-vitals',
  UNHANDLED_ERROR_LOGS = 'unhandled-error-logs',
}

export const FALLBACK_LOGS_MIDDLEWARE_ROUTE = '/__/logs';

export const DD_LOGS_CONTEXT_BY_LOGGER: Record<
  DD_BROWSER_LOGGERS,
  {
    status: 'info' | 'error' | 'warn';
  } & (
    | {
        isCritical: true;
      }
    | {
        isNonCritical: true;
      }
    | {
        isCustomError: true;
      }
    | {
        isWarning: true;
      }
    | {
        isDebug: true;
      }
    | {
        isWebVitals: true;
      }
    | {
        isUnhandled: true;
      }
  )
> = {
  [DD_BROWSER_LOGGERS.CRITICAL_LOGS]: {status: 'info', isCritical: true},
  [DD_BROWSER_LOGGERS.NON_CRITICAL_LOGS]: {status: 'info', isNonCritical: true},
  [DD_BROWSER_LOGGERS.CUSTOM_ERROR_LOGS]: {
    status: 'error',
    isCustomError: true,
  },
  [DD_BROWSER_LOGGERS.WARNING_LOGS]: {status: 'warn', isWarning: true},
  [DD_BROWSER_LOGGERS.DEBUG_LOGS]: {status: 'warn', isDebug: true},
  [DD_BROWSER_LOGGERS.WEB_VITALS]: {status: 'info', isWebVitals: true},
  [DD_BROWSER_LOGGERS.UNHANDLED_ERROR_LOGS]: {
    status: 'error',
    isUnhandled: true,
  },
};

export const DD_ENV_NAME_MAP: Record<Environment, string> = {
  production: 'ayou-live',
  preview: 'ayou-test',
  staging: 'ayou-prev',
  development: 'local',
};
